import "select2"

$(function () {
    $('select.select2').select2()
    $("select.select2-search-disable").select2({minimumResultsForSearch: Infinity})
})
